var date = {
  "abbr_day_names": ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  "abbr_month_names": [null, "ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
  "day_names": ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],
  "formats": {
    "default": "%d/%m/%Y",
    "long": "%e %B %Y",
    "short": "%-d de %b",
    "datepicker2": "%d %b %Y",
    "short_day": "%a %e %b",
    "month_year": "%b %Y",
    "day_only": "%d",
    "long_month_only": "%B",
    "long_year_only": "%Y",
    "long_month_year": "%B %Y",
    "myenlighten_month": "%m/%Y",
    "graph": {
      "long": "%a %e %b %Y",
      "x_axis": {
        "day": "%e-%b",
        "week": "%e-%b"
      }
    },
    "jquery": {
      "datepicker": "d/m/y",
      "datepicker2": "d M yy",
      "power_playback": "ddd d MMM yyyy HH:mm",
      "myenlighten": "dd/mm/yyyy",
      "datejs_formatter": "dd/M/yyyy",
      "myenlighten_month": "mm/yyyy",
      "myenlighten_overview": "D, d M yyyy",
      "datejs_month_formatter": "M/yyyy"
    },
    "js": {
      "short_month": "%b",
      "short_day_year": "%a %e %b %Y",
      "short_month_day": "%e&nbsp;%B&nbsp;%Y",
      "short_month_day_time": "%e %B %Y – %H:%M"
    }
  },
  "month_names": [null, "enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
  "order": ["day", "month", "year"],
  "range": {
    "presets": {
      "today": "Hoy",
      "last7Days": "Los últimos 7 días",
      "monthToDate": "Mes a la Fecha",
      "yearToDate": "hasta la fecha"
    }
  }
};
module.exports = date;